<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-16 10:14:50
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-12-27 08:54:57
-->
<template>
  <el-dialog class="inPlan" title="参与的考试计划" top="5vh" :visible.sync="visible" width="960px">
    <table-list
      v-if="visible"
      :search-form="searchForm(this)"
      :data="inPlanList"
      :columns="columns"
      @search="onSearch"
    ></table-list>
    <div class="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="visible = false">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// 搜索框配置
const searchForm = _this => [
  {
    label: '计划名称',
    type: 'select',
    prop: 'planId',
    children: _this.filterPlanList.map(item => ({
      value: item.key,
      label: item.value,
    })),
    remoteMethod: query => {
      _this.getFilterPlanList(query)
    },
  },
]
// 表格列配置
const columns = [
  {
    prop: 'planId',
    label: '计划ID',
    minWidth: 150,
    twoLines: true,
  },
  {
    prop: 'examPlanName',
    label: '计划名称',
    minWidth: 200,
    twoLines: true,
  },
  {
    prop: 'jobName',
    label: '职业',
    minWidth: 120,
  },
  {
    prop: 'workTypeName',
    label: '工种',
    minWidth: 120,
  },
]
import { proctorPlan, filterPlan } from '@/api/system'
import to from 'await-to'
import TableList from '@/components/TableList'
export default {
  name: 'InPlan',
  components: { TableList },
  data() {
    return {
      searchForm,
      columns,
      visible: false,
      queryParams: {},
      filterPlanList: [],
      inPlanList: [],
      id: '',
    }
  },
  methods: {
    show(id) {
      this.userId = id
      this.queryParams = {}
      this.visible = true
      this.getList()
      this.getFilterPlanList()
    },
    async getFilterPlanList(query = '') {
      const [res, err] = await to(filterPlan({ planName: query }))
      if (err) return this.$message.warning(err.msg)
      this.filterPlanList = res.data
    },
    async getList() {
      const [res, err] = await to(proctorPlan({ ...this.queryParams, userId: this.userId }))
      if (err) return this.$message.warning(err.msg)
      this.inPlanList = res.data
    },
    // 查询按钮
    onSearch(queryParams) {
      this.queryParams = queryParams
      this.getList()
    },
  },
}
</script>
<style lang="scss" scoped>
.inPlan {
  /deep/ .el-table__body-wrapper {
    height: calc(100% - 102px) !important;
  }
  /deep/.table-main {
    height: 473px;
    .el-table {
      height: 100% !important;
    }
  }
  .footer {
    display: flex;
    padding-top: 16px;
    .el-button {
      &:first-child {
        margin-left: auto;
      }
    }
  }
}
</style>
